import React, { useEffect, useState } from "react";
import { Tabs, Tab } from "@mui/material";
import CardComponent from "../../../components/common/PostCard/PostCard";
import { PostTitle, TabContainer } from "./SecondNavbar.styles";
import SearchBarProfile from "views/OrganizationProfile/SearchBarProfile/SearchBarProfile";
import PostCard from "../../../components/common/PostCard/PostCard";
import { useParams } from "react-router-dom";
import { useAppDispatch } from "store/hooks";
import { changeFeedType } from "store/feed/feed.slice";
import { RootState } from "store/types";
import { useSelector } from "react-redux";

interface Props {
  setTab: (event: React.SyntheticEvent, newValue: string) => void;
  tab: string;
  searchText: string;
  onSearch: (text: string) => void;
  onFilterChange: (text: string) => void;
}

function SecondNavbar({
  setTab,
  tab,
  searchText,
  onSearch,
  onFilterChange,
}: Props) {
  const auth = useSelector((state: RootState) => state.auth);
  const publicUserId = useParams().publicUserId;
  const [filter, setFilter] = useState("mostRecent");

  const handleFilterChange = (newFilter: string) => {
    setFilter(newFilter);
    onFilterChange(newFilter);
  };

  return (
    <>
      {/* <TabContainer>
        <Tabs
          value={tab}
          onChange={setTab}
          TabIndicatorProps={{ style: { display: "none" } }}
          aria-label="secondary tabs example"
        >
          <Tab value="For-you" label="For you" />
          <Tab value="Community-Posts" label="Community Posts" />
        </Tabs>
      </TabContainer> */}
      <PostTitle>Posts</PostTitle>
      <SearchBarProfile
        onSearch={onSearch}
        onFilterChange={handleFilterChange}
        ownProfile={!Boolean(publicUserId)}
      />
      <PostCard
        searchText={searchText}
        filter={filter}
        publicUserId={publicUserId ? Number(publicUserId) : auth.userId}
      />
    </>
  );
}

export default SecondNavbar;
